import type { LegacyMatch } from "../api/legacyTypes";
import { dateTimeSortValue, parseDateTime } from "./dateTime";

export function endOfNextLocalDay(now = Date.now()) {
  const boundary = new Date(now);
  boundary.setDate(boundary.getDate() + 1);
  boundary.setHours(23, 59, 59, 999);
  return boundary.getTime();
}

export function feedMatches(matches: LegacyMatch[], now = Date.now()) {
  const boundary = endOfNextLocalDay(now);
  return matches
    .filter((match) => {
      if (match.status === "completed") return false;
      if (match.status === "ongoing") return true;
      const startsAt = parseDateTime(match.startsAt);
      return Boolean(startsAt && startsAt.getTime() <= boundary);
    })
    .sort((left, right) => dateTimeSortValue(left.startsAt) - dateTimeSortValue(right.startsAt));
}
